export const isEmailValid = (email: string) =>
  Boolean(email.match(/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g));
